export default class ApiError {
    public original: any;
    public message: string;

    constructor(error: any) {
        this.original = error;
        this.message = error.statusText;
    }
}